module.exports = __webpack_public_path__ + "static/media/product_sample_12.00f42b4b.jpg";